<template>
  <b-row class="dashboard-indicadores-historico-gastos">
    <b-col cols="12">
      <label class="titulo" v-if="showTitulo">Gastos</label>
      <b-table hover
          responsive="sm" 
          class="registro"
          :busy="tableBusy"
          :items="indicadoresGastos" 
          :fields="indicadoresGastosFields">
        <div slot="table-busy" class="text-center">
          <b-spinner class="table-spinner" label="Spinning" />
        </div>
        <template v-slot:cell(pjeObjetivo)="data">
          {{ data.item.pjeObjetivo | porcentaje }}
        </template>
        <template v-slot:cell(montoNetoVentas)="data">
          {{ data.item.montoNetoVentas | moneda }}
        </template>
        <template v-slot:cell(montoNetoComprasGastos)="data">
          {{ (data.item.montoNetoCompras + data.item.montoNetoGastos) | moneda }}
        </template>
        <template v-slot:cell(pjeActual)="data">
          {{ data.item.pjeActual | porcentaje }}
        </template>

        <template v-slot:cell(detailShowing)="row">
          <b-btn class="detailShowing" 
              size="sm" 
              @click.stop="row.toggleDetails">
            {{ ( row.detailsShowing) ? '-' : '+' }}
          </b-btn>            
        </template>

        <template v-slot:row-details="row">
          <b-row>
            <b-col cols="12">
              <p>Información del Indicador:</p>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="2">
              <p class="descripcion">Ventas</p>
            </b-col>
            <b-col cols="10">
              <p class="descripcion">{{ row.item.montoNetoVentas | moneda }}</p>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="2">
              <p class="descripcion">Compras</p>
            </b-col>
            <b-col cols="2">
              <p class="descripcion">{{ row.item.montoNetoCompras | moneda }}</p>
            </b-col>
            <b-col cols="8">
              <p class="descripcion">{{ row.item.pjeCompras | porcentaje }}</p>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="2">
              <p class="descripcion">Gastos</p>
            </b-col>
            <b-col cols="2">
              <p class="descripcion">{{ row.item.montoNetoGastos | moneda }}</p>
            </b-col>
            <b-col cols="8">
              <p class="descripcion">{{ row.item.pjeGastos | porcentaje }}</p>
            </b-col>
          </b-row>
        </template>

        <template v-slot:cell(opciones)="data">
          <b-dropdown v-if="verDatosComprasGastos"
              variant="link" toggle-class="text-decoration-none" no-caret>
            <template slot="button-content">
              <i class="fa fa-ellipsis-v"></i>
            </template>

            <b-dropdown-item 
                @click.stop="exportarCompras(data.item)">
              <i class="fa fa-file-excel-o"></i>Exportar Compras</b-dropdown-item>
            <b-dropdown-item 
                @click.stop="exportarGastos(data.item)">
              <i class="fa fa-file-excel-o"></i>Exportar Gastos</b-dropdown-item>
            <b-dropdown-item 
                @click.stop="exportarOrdenesInternas(data.item)">
              <i class="fa fa-file-excel-o"></i>Exportar Órdenes Internas (Gastos)</b-dropdown-item>
          </b-dropdown>
        </template>

      </b-table>
    </b-col>
  </b-row>
</template>

<script>

export default {
  props: {
    showTitulo: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      indicadoresGastos: [],
      indicadoresGastosFields: [
        {
            key: 'detailShowing',
            label: '',
            class: 'text-center'
        },
        { 
          key: 'indicadorPeriodo',
          label: 'Periodo' 
        },
        { 
          key: 'pjeObjetivo',
          class: 'text-right'
        },
        { 
          key: 'montoNetoVentas',
          label: 'Ventas',
          class: 'text-right'
        },
        { 
          key: 'montoNetoComprasGastos',
          label: 'Compras-Gastos',
          class: 'text-right'
        },
        { 
          key: 'pjeActual',
          label: 'Pje Real',
          class: 'text-right'
        },
        { 
          key: 'descripcion',
          label: 'Descripción'
        },
        {
          key: 'opciones',
          label: '',
          class: 'text-center'
        }
      ],

      tableBusy: false,
      verDatosComprasGastos: false
    }
  },
  created() {
    let userRolId = parseInt(this.$store.getters['user/rolId']);

    switch (userRolId) {
        case 1: /* Superadministrador */ 
        case 2: /* Direccion */
        case 4: /* Produccion */ 
        case 6: /* Director Administrativo */
        case 7: /* Asistente de administracion */
        case 8: /* Calidad */
        case 9: /* Director Ejecutivo */
        case 20: /* Gerente Comercial */
        case 21: /* Responsable de Finanzas y Proveedores */
        case 22: /* Responsable de Facturacion e Impuestos */
        case 23: /* Asistente de Calidad */
          this.verDatosComprasGastos = true;
          break;

        case 3: /* Cuentas */ 
        case 5: /* Diseño */
        case 10: /* Asistente de logistica */
        case 11: /* RRHH */
        case 12: /* Asistente de promociones */
        case 13: /* Asistente de cuentas */
        case 14: /* Asistente de produccion */
        case 15: /* Coordinador/a de promociones */
        case 16: /* Ejecutivo comercial */
        case 17: /* Asistente comercial */
        case 19: /* Coordinador/a comercial */
        case 24: /* Coordinador de Diseño */
          break;
    }
  },
  methods: {
    getIndicadores() {
        this.tableBusy = true;
        this.$store.dispatch('resultadosIndicadores/getIndicadoresGastosHistorico')
          .then(() => {
            this.indicadoresGastos = this.$store.getters['resultadosIndicadores/indicadoresGastosHistorico'];
            this.tableBusy = false;
          });
    },
    exportarCompras(item) {
      let params = {
        fechaDesde: item.fechaDesde,
        fechaHasta: item.fechaHasta,
      }

      this.showSpinner();
      this.$store.dispatch('resultadosIndicadores/getIndicadorGastosDetalleComprasHistorico', params)
        .then(() => {
          let exportXls = Boolean(false); 
          let compras = this.$store.getters['resultadosIndicadores/indicadorGastosComprobantes'];

          if (compras) {
            if (compras.length != 0) {
              exportXls = Boolean(true);
            }
          }
          if (exportXls) {
            let title= 'Detalle de Compras';
            let fileName = 'compras';
            let format = [
              { titulo: 'Proveedor', nombre: 'proveedor', formato: '' },
              { titulo: 'Fecha', nombre: 'fechaComprobante', formato: 'fecha' },
              { titulo: 'Comprobante', nombre: 'comprobante', formato: '' },
              { titulo: 'Neto Comprobante', nombre: 'montoNetoComprobante', formato: '' },
              // { titulo: 'Neto Gastos Producción', nombre: 'montoNetoGastosProduccion', formato: '' },
              { titulo: 'Neto Ordenes Proveedores', nombre: 'montoNetoOrdenesProveedores', formato: '' },
              { titulo: 'Neto Remitos', nombre: 'montoNetoRemitos', formato: '' },
              { titulo: 'Amortización - Años', nombre: 'amortizacionAnios', formato: '' },
            ];

            this.exportXLS(title, fileName, compras, format);
          } else {
            //this.showModalMsj('No hay datos para exportar', null, null, 'light')
          }
        })
        // .catch(error => this.showErrorMsj(error))
        .finally(() => this.hideSpinner());
    },
    exportarGastos(item) {
      let params = {
        fechaDesde: item.fechaDesde,
        fechaHasta: item.fechaHasta,
      }

      this.showSpinner();
      this.$store.dispatch('resultadosIndicadores/getIndicadorGastosDetalleGastosHistorico', params)
        .then(() => {
          let exportXls = Boolean(false); 
          let compras = this.$store.getters['resultadosIndicadores/indicadorGastosComprobantes'];

          if (compras) {
            if (compras.length != 0) {
              exportXls = Boolean(true);
            }
          }
          if (exportXls) {
            let title= 'Detalle de Gastos';
            let fileName = 'gastos';
            let format = [
              { titulo: 'Proveedor', nombre: 'proveedor', formato: '' },
              { titulo: 'Fecha', nombre: 'fechaComprobante', formato: 'fecha' },
              { titulo: 'Comprobante', nombre: 'comprobante', formato: '' },
              { titulo: 'Neto Comprobante', nombre: 'montoNetoComprobante', formato: '' },
              { titulo: 'Cuenta', nombre: 'cuenta', formato: '' },
              { titulo: 'Rubro', nombre: 'rubro', formato: '' },
              { titulo: 'Subrubro', nombre: 'subrubro', formato: '' },
              { titulo: 'Neto Gastos', nombre: 'montoNetoGastos', formato: '' },
              { titulo: 'Amortización - Años', nombre: 'amortizacionAnios', formato: '' },
            ];

            this.exportXLS(title, fileName, compras, format);
          } else {
            // this.showModalMsj('No hay datos para exportar', null, null, 'light')
          }
        })
        // .catch(error => this.showErrorMsj(error))
        .finally(() => this.hideSpinner());
    },
    exportarOrdenesInternas(item) {
      let params = {
        fechaDesde: item.fechaDesde,
        fechaHasta: item.fechaHasta,
      }

      this.showSpinner();
      this.$store.dispatch('resultadosIndicadores/getIndicadorGastosDetalleOrdenesInternasHistorico', params)
        .then(() => {
          let exportXls = Boolean(false); 
          let compras = this.$store.getters['resultadosIndicadores/indicadorGastosComprobantes'];

          if (compras) {
            if (compras.length != 0) {
              exportXls = Boolean(true);
            }
          }
          if (exportXls) {
            let title= 'Detalle de Ordenes';
            let fileName = 'ordenes-internas';
            let format = [
              { titulo: 'Proveedor', nombre: 'proveedor', formato: '' },
              { titulo: 'Fecha', nombre: 'fechaComprobante', formato: 'fecha' },
              { titulo: 'Comprobante', nombre: 'comprobante', formato: '' },
              { titulo: 'Neto Comprobante', nombre: 'montoNetoComprobante', formato: '' },
              { titulo: 'Neto Ordenes Internas', nombre: 'montoNetoOrdenesProveedoresInternas', formato: '' },
              { titulo: 'Amortización - Años', nombre: 'amortizacionAnios', formato: '' },
            ];

            this.exportXLS(title, fileName, compras, format);
          } else {
            // this.showModalMsj('No hay datos para exportar', null, null, 'light')
          }
        })
        // .catch(error => this.showErrorMsj(error))
        .finally(() => this.hideSpinner());
    },
  }
}
</script>

<style>
  .dashboard-indicadores-historico-gastos .registro table td[aria-colindex="1"] {
    width: 30px !important;
  }
  .dashboard-indicadores-historico-gastos .registro table td[aria-colindex="2"] {
    width: 30% !important;
  }
  .dashboard-indicadores-historico-gastos .registro table td[aria-colindex="3"],
  .dashboard-indicadores-historico-gastos .registro table td[aria-colindex="4"] {
    width: 10% !important;
  }
  .dashboard-indicadores-historico-gastos .registro table td[aria-colindex="5"],
  .dashboard-indicadores-historico-gastos .registro table td[aria-colindex="6"] {
    width: 12% !important;
  }
  .dashboard-indicadores-historico-gastos .registro table td[aria-colindex="7"] {
    width: calc(28% - 30px) !important;
  }

  .dashboard-indicadores-historico-gastos .registro table tr.b-table-details td {
    padding-left: 30px;
    padding-bottom: 30px;
  }
  .dashboard-indicadores-historico-gastos .registro table tr.b-table-details td .row {
    margin-bottom: 0px !important;
  }
  .dashboard-indicadores-historico-gastos .registro table tr.b-table-details td .row p {
    margin-bottom: 5px !important;
  }
</style>